export function initBrazeWebSDK() {
  if (typeof window === 'undefined') {
    return;
  }

  const appboy = require('@braze/web-sdk');

  window.appboy = appboy;

  appboy.initialize('d870e632-b86a-486a-a39b-23b474c70066', {
    baseUrl: 'sdk.iad-03.braze.com',
    enableLogging: true,
  });

  appboy.display.automaticallyShowNewInAppMessages();
  appboy.registerAppboyPushMessages();
  appboy.openSession();
}
